import { differenceInYears } from 'date-fns';
import { LoginStatus } from '@klant/conversational-connector/klant-conversational-connector.model';

import { DestroyRef, Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { ApAnalyticsService } from '@ap/analytics';
import { ClickAnalyticsData } from '@ap/analytics';
import { ApPageviewDataService } from '@ap/analytics';
import { ApContentService } from '@ap/content';
import { KlantbeheerResource, KlantDetails } from '@ap/interface-apic-klantbeheer';

import content from './analytics.json';

@Injectable({ providedIn: 'root' })
export class ConversationalConnectorAnalyticsService {
    private readonly analyticsService = inject(ApAnalyticsService);
    private readonly contentService = inject(ApContentService);
    private readonly pageviewDataService = inject(ApPageviewDataService);
    private readonly klantbeheerResource = inject(KlantbeheerResource);
    private readonly destroyRef = inject(DestroyRef);

    public constructor() {
        this.contentService.addContentItems(content);
    }

    public pushAnalyticsPageview(loginStatus: LoginStatus): void {
        let pageviewData = this.pageviewDataService.getPageviewData(
            this.contentService.get('conversational.connector.analytics.page.type'),
            this.contentService.get('conversational.connector.analytics.product.name'),
            this.contentService.get('conversational.connector.analytics.product.category'),
            this.contentService.get('conversational.connector.analytics.page.site.segment'),
            this.contentService.get('conversational.connector.analytics.page.site.section'),
            this.contentService.get('conversational.connector.analytics.platform.name'),
            ['pageview']
        );

        if (loginStatus === LoginStatus.ANONYMOUS) {
            this.analyticsService.push(pageviewData);
            return;
        }

        this.klantbeheerResource
            .geefIngelogdeKlantDetails()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((klantDetails: KlantDetails) => {
                pageviewData.userAgeRange = this.determineAgeRange(
                    differenceInYears(new Date(), new Date(klantDetails.geboorte_oprichtings_datum))
                );
                this.analyticsService.push(pageviewData);
            });
    }

    private determineAgeRange(age: number): string {
        if (age < 18) {
            return '[0]-[17]';
        }
        if (age >= 18 && age < 25) {
            return '[18]-[24]';
        }
        if (age >= 25 && age < 35) {
            return '[25]-[34]';
        }
        if (age >= 35 && age < 45) {
            return '[35]-[44]';
        }
        if (age >= 45 && age < 55) {
            return '[45]-[54]';
        }
        if (age >= 55 && age < 65) {
            return '[55]-[64]';
        }
        if (age >= 65) {
            return '[65]-[max]';
        }
        return 'Age not determined';
    }

    public clickEvent(clickedElement: string, clickAction: string): void {
        this.analyticsService.push(new ClickAnalyticsData(clickedElement, clickAction));
    }
}
